module.exports = __webpack_public_path__ + "img/bi.06f36479.svg";